import './InquiryPages.css';
import TourJourney from '../components/TourJourney';
import ClubLocations from '../components/ClubLocations';
import SEO from '../components/SEO';

const BookTourPage = () => (
  <div className="dv-inquiries dv-inquiries--booktour" data-testid="book-tour-page">
    <SEO
      title="Book a Tour"
      description="Book a tour of Delta Valley Health Club in Brentwood or Discovery Bay and find the right membership, programs, and amenities for your goals."
      keywords="book gym tour Brentwood, book gym tour Discovery Bay, Delta Valley tour"
    />
    <TourJourney defaultInterests={['Membership']} />

    <ClubLocations />
  </div>
);

export default BookTourPage;
